import React, { useEffect, useState } from 'react';
import { Oval } from 'react-loader-spinner';
import style from './Career.module.css';
import axios from 'axios';
import { Link } from 'react-router-dom';

const Career = () => {
  const [loading, setLoading] = useState(true);
  const [career, setCareer] = useState([]);

  const handleDelete = async (id) => {
    await axios.delete(`/career/${id}`, {
      headers: { 'Access-Control-Allow-Origin': '*' },
      withCredentials: true,
    });
  };

  useEffect(() => {
    const allCareer = async () => {
      await axios
        .get('/career', {
          headers: { 'Access-Control-Allow-Origin': '*' },
          withCredentials: true,
        })
        .then((res) => {
          setLoading(false);
          setCareer(res.data);
        })
        .catch(() => setLoading(false));
    };
    allCareer();
  }, []);
  return (
    <div>
      {!loading ? (
        career.length != 0 ? (
          <div className={style.tile}>
            {career.map((p, i) => {
              return (
                <div className={style.career} key={p._id}>
                  <div>
                    <div>
                      {p.title} - {p.type}
                    </div>
                    <div className={style.Link}>
                      <a
                        className={style.ink}
                        target='_blank'
                        rel='noreferrer'
                        href={p.description.startsWith('http') ? p.description : `https://${p.description}`}
                      >
                        Click Here
                      </a>
                    </div>
                  </div>
                  <div onClick={() => handleDelete(p._id)}>
                    <i
                      style={{ cursor: 'pointer' }}
                      className='far fa-trash-alt fa-2x'
                    ></i>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className={style.Center} style={{ fontWeight: '500' }}>
            No job found!
          </div>
        )
      ) : (
        <div className={style.Center}>
          <Oval
            ariaLabel='loading-indicator'
            height={80}
            width={80}
            strokeWidth={5}
            color='white'
            secondaryColor='purple'
          />
        </div>
      )}
      <Link to='/admin/career/add'>
        <div className={style.Add}>
          <i className='fas fa-plus-square fa-3x'></i>
        </div>
      </Link>
    </div>
  );
};

export default Career;
